import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@medflex/components/stories/Modal';
import Button from '@medflex/components/stories/Button';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import useSessionMeetings from '../hooks/useSessionMeetings';
import useModal from '../hooks/useModal';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';

const SessionsRemoveParticipantModule = () => {
  const { removeParticipant, futureMeetings } = useSessionMeetings();
  const [session, setSession] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const { sessionId, participantId } = useLocationSearchParams();
  const { close, open } = useModal();
  const { t } = useTranslation('physician');

  const closeModal = () => {
    close({ modal: 'sessionsRemoveParticipant', participantId });
    open({ modal: 'sessionsDetail' });
  };

  useEffect(() => {
    if (sessionId && futureMeetings) {
      const s = futureMeetings.find(cur => cur.id === sessionId);
      if (!s) closeModal();
      setSession(s);
    }
  }, [sessionId, futureMeetings]);

  const participant = useMemo(() => {
    if (session) {
      const { participants } = session;
      return participants.find(p => p.participantId === participantId);
    }
    return null;
  }, [session]);

  const handleRemove = async () => {
    try {
      if (!submitted) {
        setSubmitted(true);
        await removeParticipant({ sessionId, participantId });
        closeModal();
        showSuccessToast(t('SessionsRemoveParticipantModule.success'), null, {
          toastId: 'SessionRemoveParticipantSuccess',
        });
      }
    } catch {
      setSubmitted(false);
      showAlertToast(t('toasts.generic_failure.title'), t('toasts.generic_failure.text'), {
        toastId: 'SessionRemoveParticipantFailed',
      });
    }
  };

  return (
    <Modal
      showCloseButton
      onClickCloseButton={() => {
        closeModal();
      }}
      title={t('SessionsRemoveParticipantModule.title', {
        name:
          participant &&
          (participant.fullNameWithTitle ||
            getFullNameWithTitle({ id: participant.userId, ...participant })),
      })}
    >
      <div data-component="SessionsRemoveParticipantModule" className="flex flex-col">
        <p>{t('SessionsRemoveParticipantModule.text')}</p>
      </div>
      <p className="flex justify-end lg:justify-center w-full mt-16 lg:mt-8 mb-4">
        <Button
          isDisabled={submitted}
          isLoading={submitted}
          className="w-128"
          type="button"
          onClick={handleRemove}
        >
          {t('SessionsRemoveParticipantModule.button')}
        </Button>
      </p>
    </Modal>
  );
};

export default SessionsRemoveParticipantModule;
